// Client V2 common imports
const { FetchStateEnum } = require('client-v2/common/utils/enums')
// Sibling imports
const {
  SHARES_UNREAD_COUNT_FAILED,
  SHARES_UNREAD_COUNT_LOADED,
  SHARES_UNREAD_COUNT_LOADING,
  UPDATE
} = require('./actions')
const SelfUserRecord = require('./record')

function userReducer(state = new SelfUserRecord(), { type, payload }) {
  switch (type) {
    case SHARES_UNREAD_COUNT_FAILED:
      return state.set('sharesUnreadCountState', FetchStateEnum.FAILED)
    case SHARES_UNREAD_COUNT_LOADED:
      return state.merge({
        sharesUnreadCount: payload.unreadCount,
        sharesUnreadCountState: FetchStateEnum.LOADED
      })
    case SHARES_UNREAD_COUNT_LOADING:
      return state.set('sharesUnreadCountState', FetchStateEnum.LOADING)
    case UPDATE:
      return state.mergeDeep(payload)
    default:
      return state
  }
}

module.exports = userReducer
